import { OrganizationMapperParams } from '../structuredMappers/organization';
import { WebsiteDataResult } from '../useWebsiteData';

export const rawToOrganization = ({
  logo,
  settings,
  origin,
}: Partial<WebsiteDataResult> = {}): OrganizationMapperParams => ({
  logo: logo?.logo.large_image.url || '',
  name: settings?.site_name || '',
  url: origin || '',
});
